import { Container } from "@material-ui/core";
import { CtrlCollection } from "@yuigoto/ctrl";
import { CouponControl } from "controls/CouponControl";
import { Component } from "react";
import { connect } from "react-redux";
import { UiActions } from "state/actions/UiActions";
import { PartnerInfoActions } from "state/actions/user/PartnerInfoActions";
import React from "react";
import { Row } from "components/grid/Row";
import { Col } from "components/grid/Col";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import Styles from "views/pages/DadosPessoais.module.scss";
import { PersonActions } from "state/actions/user/PersonActions";

class MeuCupom extends Component {
  constructor(props) {
    super(props);
    this.state={
      couponName: props.person.couponName,
      editedClass: props.person.dateCouponNameEdited === null ? null : "editado",
      edited: props.person.dateCouponNameEdited !== null 
    }

    this.collection = new CtrlCollection();
    for (let i in CouponControl) {
      if (Array.isArray(CouponControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n in CouponControl[i]) {

          let gpInfoValue = this.props.person.couponName;
          gpInfoValue = (!gpInfoValue) ? gpInfoValue : this.props.person.couponName.toString();

          CouponControl[i][n].value = gpInfoValue;

          tempCollection.add(CouponControl[i][n]);
        }

        this.collection.collection.push(tempCollection);
      } else {
       
        CouponControl[i].value = this.props.person.couponName;

        this.collection.add(CouponControl[i]);
      }
    }
  }

  changeCouponName = (event) => {
    event.preventDefault();
    let couponName = this.collection.get("couponName").value;

    if (couponName !== "") {
      let couponNameObj = { 
        newCouponName: couponName,
        oldCouponName: this.props.person.couponName
      };

      this.props.setCouponName(
          couponNameObj,
        (response) => {
          let { statusCode, result } = response;
          if (statusCode === 200) {            
            this.setState({ editedClass: "editado" , disabled: true});  
            this.props.publishSuccessAlert(result.message);

            this.props.person.couponName = couponName;
              
          } else {
            this.props.publishErrorAlert(result.message);
          }

          this.props.onFinish();
        }
        
      );
    }
  }

  render() {
    const { edited } = this.state;
    return(           

          <div className={"gb-contentblock"}>
            <form onSubmit={this.changeCouponName}>
              {ControlRenderer.renderCollection(this.collection)}
              <div className={Styles['info__buttons']}>
                <button className={"btn btn-light-pink btn-md"} disabled={edited}>
                  Salvar
                </button>
              </div>
            </form>
          </div>
     
    );
  }
}
const mapStateToProps = (state) => ({
  store: state,
  partner: state.partnerGeneral.data,
  token: state.token.data,
  person: state.person.data.person

});

const mapDispatchToProps = (dispatch) => {
  return {
    setCouponName: (couponObj, callback) => {
      dispatch(PersonActions.setCouponName(couponObj, callback));
    },
    partnerUpdate: (partner, callback) => {
      dispatch(PartnerInfoActions.savePartnerData(partner, callback))
    },
    publishSuccessAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    },
    publishErrorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    },
    loaderShow: () => {
      dispatch(UiActions.loaderShow())
    },
    loaderHide: () => {
      dispatch(UiActions.loaderHide())
    }
  }
}
MeuCupom = connect(mapStateToProps, mapDispatchToProps)(MeuCupom);

export { MeuCupom };
